var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBellSlash = function SvgIconBellSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.767 4.454A5.7 5.7 0 0 1 12.038 4c3.146.024 5.693 2.644 5.693 5.834v.66c-.014 1.32.112 2.636.377 3.929a1 1 0 1 0 1.96-.402 16.5 16.5 0 0 1-.337-3.51v-.677c0-4.253-3.397-7.801-7.676-7.834a7.7 7.7 0 0 0-3.072.615 1 1 0 0 0 .784 1.84"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.24 3.077a1 1 0 1 0-1.48 1.346l1.456 1.601a7.8 7.8 0 0 0-.947 3.726v.75c0 3.215-.672 4.985-1.187 5.874v.001A1.75 1.75 0 0 0 4.59 19h3.417a4 4 0 0 0 7.984 0h1.02l1.748 1.923a1 1 0 0 0 1.48-1.346l-2.008-2.208a1 1 0 0 0-.073-.08zM6.269 9.75c0-.73.138-1.45.403-2.124L15.194 17H5.016c.65-1.285 1.253-3.331 1.253-6.5zM10.016 19h3.968a2 2 0 0 1-3.968 0",
    clipRule: "evenodd"
  }))));
};
export default SvgIconBellSlash;